import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';
import api from '../../services/api';

import { Container, Content } from './styles';

import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import Dashboard from '../../components/Dashboard';

export default function Main({
  match: {
    params: { product },
  },
}) {
  function getMonthDateRange() {
    const start = moment()
      .startOf('month')
      .format('DD-MM-YYYY');
    const end = moment()
      .endOf('month')
      .format('DD-MM-YYYY');

    return { start, end };
  }

  const [dates, setDates] = useState([getMonthDateRange().start, getMonthDateRange().end]);
  const [dashboardDate, setdashboardDate] = useState({});
  const [loading, setLoading] = useState(true);

  function handleChangeDate(_date, dateString) {
    setDates(dateString);
  }

  useEffect(() => {
    const start = moment(dates[0], 'DD-MM-YYYY').format('YYYY-MM-DD');
    const end = moment(dates[1], 'DD-MM-YYYY').format('YYYY-MM-DD');

    async function getDashboardData() {
      setLoading(true);
      const queryProduct = product || 'all';
      try {
        const {
          data: { data },
        } = await api.get(`dashboard/${queryProduct}?start=${start}&end=${end}`);
        setdashboardDate(data);
        setLoading(false);
      } catch (err) {
        console.log('err', err);
      }
    }
    getDashboardData();
  }, [dates, product]);

  return (
    <Container>
      <Header
        changeDate={(date, dateString) => handleChangeDate(date, dateString)}
        getMonthDateRange={getMonthDateRange}
      />
      <Content>
        {dashboardDate.balances && <Sidebar product={product} data={dashboardDate} />}

        <Dashboard loading={loading} dates={dates} data={dashboardDate} product={product || 'all'} />
      </Content>
    </Container>
  );
}

Main.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      product: PropTypes.string,
    }),
  }).isRequired,
};
